import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { getLabTrustSnapshot } from './api/smartiLabApi';

const SmartiLabContext = createContext(null);

export function SmartiLabProvider({ currentUser, children }) {
  const isAdmin = currentUser?.role === 'admin';
  const [scope, setScope] = useState('mine');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [trustSnapshot, setTrustSnapshot] = useState(null);

  useEffect(() => {
    let active = true;
    getLabTrustSnapshot({
      scope: isAdmin ? scope : 'mine',
      startDate,
      endDate,
    }).then((result) => {
      if (active) setTrustSnapshot(result);
    }).catch(() => {});
    return () => {
      active = false;
    };
  }, [endDate, isAdmin, scope, startDate]);

  const value = useMemo(() => ({
    currentUser,
    isAdmin,
    scope,
    setScope: (nextScope) => setScope(isAdmin ? nextScope : 'mine'),
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    sharedQuery: {
      scope: isAdmin ? scope : 'mine',
      startDate,
      endDate,
    },
    trustSnapshot,
    refreshTrustSnapshot: async () => {
      const result = await getLabTrustSnapshot({
        scope: isAdmin ? scope : 'mine',
        startDate,
        endDate,
      });
      setTrustSnapshot(result);
      return result;
    },
  }), [currentUser, endDate, isAdmin, scope, startDate, trustSnapshot]);

  return <SmartiLabContext.Provider value={value}>{children}</SmartiLabContext.Provider>;
}

export function useSmartiLabContext() {
  const context = useContext(SmartiLabContext);
  if (!context) {
    throw new Error('useSmartiLabContext must be used within SmartiLabProvider');
  }
  return context;
}
